var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBeegruPointsLogo = function SvgBeegruPointsLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FC8019",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.948,
    cy: 11.948,
    r: 9.891,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC8019",
    d: "M14.126 11.855q.946.177 1.556.947t.61 1.765q0 .898-.45 1.588-.432.675-1.267 1.06-.834.384-1.974.384h-4.83V6.4h4.622q1.14 0 1.957.37.835.368 1.252 1.026.433.658.433 1.493 0 .979-.53 1.636-.513.659-1.38.931m-4.108-.834h2.054q.803 0 1.235-.353.435-.37.434-1.043 0-.675-.434-1.043-.433-.37-1.235-.37h-2.054zm2.262 4.75q.82-.001 1.268-.386.465-.385.465-1.091 0-.722-.481-1.123-.481-.417-1.3-.417h-2.214v3.016z"
  })));
};
export default SvgBeegruPointsLogo;